import axios from 'axios';
import { UserDetailsResponse, GetEOAsResponse, GetEOAPubNubTokenResponse } from '../interfaces/UserDetailsInterface';

const BASE_URL = process.env.REACT_APP_BASE_URL;

interface LogoutResponse {
  mfa_enrollments_deleted: number;
  sessions_invalidated: boolean;
  message: string;
}

const getUserDetails = async (access_token: string) => {
  return axios.get<UserDetailsResponse>(`${BASE_URL}/users/me`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

const getEOAs = async (access_token: string, includeTest?: boolean, includePending?: boolean) => {
  const params: { include_test?: boolean; include_pending?: boolean } = {};
  if (includeTest !== undefined) params.include_test = includeTest;
  if (includePending !== undefined) params.include_pending = includePending;
  return axios.get<GetEOAsResponse>(`${BASE_URL}/eoas`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
    params,
  });
};

const getEOAPubNubToken = async (eoaId: string, access_token: string) => {
  return axios.get<GetEOAPubNubTokenResponse>(`${BASE_URL}/eoa/${eoaId}/pubnub-token`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

const invalidateSessionAndMfa = async (access_token: string) => {
  return axios.post<LogoutResponse>(
    `${BASE_URL}/logout`,
    {},
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};

export { getUserDetails, getEOAs, getEOAPubNubToken, invalidateSessionAndMfa };
